/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FrownIcon = /*#__PURE__*/ createSvgIcon(
  'FrownIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} fill="currentColor">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.983 11.92a4.22 4.22 0 00-3.81 2.119.5.5 0 01-.867-.498A5.22 5.22 0 0110 10.92a5.22 5.22 0 014.694 2.621.5.5 0 01-.868.498 4.22 4.22 0 00-3.809-2.12L10 11.92h-.017z"
            />
            <path d="M12.76 8.46c.685 0 1.24-.55 1.24-1.23C14 6.55 13.445 6 12.76 6c-.685 0-1.24.55-1.24 1.23 0 .68.555 1.23 1.24 1.23zM7.23 8.46a1.23 1.23 0 100-2.46 1.23 1.23 0 000 2.46z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default FrownIcon;
